// Environment configuration

const LOCAL_API_URL = 'http://localhost:5000/api';

// Running on localhost → local backend; otherwise the deployed API from .env
export const getApiUrl = (): string => {
  if (
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1')
  ) {
    return LOCAL_API_URL;
  }
  return process.env.REACT_APP_API_URL || LOCAL_API_URL;
};

const config = {
  // API Configuration
  API_URL: getApiUrl(),
  
  // App Configuration
  APP_NAME: 'نظام حجز الحج والعمرة',
  COMPANY_NAME: 'مكتب الحرمين',
  
  // Default vendor ID (for development)
  DEFAULT_VENDOR_ID: process.env.REACT_APP_DEFAULT_VENDOR_ID || 'default',
  
  // Feature flags
  FEATURES: {
    MULTI_VENDOR: true,
    WHATSAPP_INTEGRATION: true,
    SMS_INTEGRATION: true,
    EMAIL_INTEGRATION: true,
  },
  
  // Pagination defaults
  PAGINATION: {
    DEFAULT_PAGE_SIZE: 20,
    MAX_PAGE_SIZE: 100,
  },
  
  // Date formats
  DATE_FORMATS: {
    DISPLAY: 'DD/MM/YYYY',
    API: 'YYYY-MM-DD',
    DATETIME: 'DD/MM/YYYY HH:mm',
  },
  
  // Currency
  CURRENCY: {
    CODE: 'SAR',
    SYMBOL: 'ر.س',
    DECIMAL_PLACES: 2,
  },
};

export default config; 